import React from "react";
import { Navigate } from "react-router-dom";
import { getAuth } from "../utils/auth";

const ProtectedRoute = ({ children, role }) => {
  const auth = getAuth();

  if (!auth.token || !auth.role) {
    return <Navigate to="/login" replace />;
  }

  const currentRole = auth.role.toLowerCase();

  if (role === "admin") {
    if (
      currentRole !== "admin" &&
      currentRole !== "superadmin"
    ) {
      return <Navigate to="/login" replace />;
    }
  }

  if (role === "user") {
    if (currentRole !== "user") {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;